module.exports = __webpack_public_path__ + "media/fonts/Oricons-efeb8041c48ddf352925cc1e810ddcdd.woff";